// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__28N6J","content":"GlobalSearch_content__3Ox8e"};